// O componente Botao é um botão reutilizável que recebe classes, tipo e uma função de clique como propriedades.
const Botao = ({className, tipo, aoClicar, children, disabled}) => {
    return (
        <button 
            className={className} 
            type={tipo} 
            onClick={aoClicar}
            disabled={disabled}
        >
            {/* props.children é tudo que está entre <Botao> ... </Botao>.
            Ele permite que o botão mostre qualquer conteúdo, não só texto fixo.
            Se não usar props.children, o botão ficaria sempre vazio ou com texto fixo, perdendo flexibilidade. */}
            {children}
        </button>
    );
}

export default Botao;
